const esInbox = {
  notifications: 'Notificaciones',
  inbox: 'Bandeja',
  viewInbox: 'Ver bandeja',
  inboxPreviewEmpty: 'No hay avisos sin leer.',
  preferences: 'Preferencias',
  appSection: 'Aplicación',
  silenceNonUrgent: 'Silenciar avisos no urgentes',
  filterAll: 'Todas',
  filterUnread: 'Sin leer',
  inboxFolderAll: 'Todos',
  inboxFilterMenu: 'Ordenar y filtrar',
  inboxToday: 'Hoy',
  inboxEarlier: 'Anteriores',
  inboxTabInbox: 'Entrada',
  inboxTabSent: 'Enviados',
  inboxTabDrafts: 'Borradores',
  inboxTabCompose: 'Redactar',
  inboxTabAlerts: 'Avisos',
  inboxCompose: 'Redactar mensaje',
  inboxRecipient: 'Destinatario',
  inboxSelectRecipient: 'Elegir usuario…',
  inboxSubject: 'Asunto',
  inboxMessageBody: 'Mensaje',
  inboxChannelInApp: 'In-app',
  inboxChannelEmail: 'Correo',
  inboxSendMessage: 'Enviar',
  inboxSending: 'Enviando…',
  inboxSaveDraft: 'Guardar borrador',
  inboxDraftSaved: 'Borrador guardado',
  inboxMessageSent: 'Mensaje enviado',
  inboxMessageFailed: 'No se pudo enviar el mensaje',
  inboxNoEmail: 'sin correo',
  inboxRecipientSearch: 'Buscar por nombre, alias o correo…',
  inboxRecipientSearchGod: 'Busca usuarios, o escribe cualquier correo…',
  inboxRecipientHint: 'Solo ves personas de tu casa o de las casas a las que tienes acceso.',
  inboxRecipientHintGod:
    'Puedes escribir a cualquier usuario registrado (cualquier casa) o enviar correo a una dirección externa.',
  inboxRecipientEmpty: 'Nadie coincide. Pide al banker que invite a esa persona primero.',
  inboxExternalRecipient: 'Correo externo',
  inboxExternalEmailOnly: 'solo correo',
  inboxInviteHintGod:
    'Consejo: escribe un correo completo para contactar a alguien fuera de la plataforma. Solo se entrega por email.',
  inboxInviteHintBanker:
    'Para escribirle a alguien nuevo: invítalo desde Usuarios (el correo puede ser Gmail, iCloud, Outlook…). Cuando acepte, aparece aquí.',
  inboxInviteHintStaff:
    '¿Falta alguien? Pide al banker que invite su correo a esta casa. No puedes enviar DM a direcciones no registradas.',
  inboxBroadcastHouseBanker: 'Todos los colaboradores',
  inboxBroadcastHouseGod: 'Todos en esta casa',
  inboxBroadcastHintBanker:
    'Envía una notificación in-app a todos los colaboradores de la casa (listeros, recogedores y staff).',
  inboxBroadcastHintGod:
    'Envía una notificación in-app a todos los usuarios de la casa seleccionada.',
  inboxBroadcastInAppOnly: 'broadcast in-app',
  inboxBroadcastSent: 'Broadcast de casa enviado',
  inboxMarkUnread: 'No leído',
  inboxMarkRead: 'Leído',
  inboxImportant: 'Importante',
  inboxDelete: 'Eliminar',
  inboxSync: 'Sincronizar mensajes',
  inboxSyncing: 'Sincronizando…',
  inboxSyncDone:
    'Se añadieron {imported} a tu bandeja ({matched} de {scanned} correos en Resend eran para support@).',
  inboxEmptyMail: 'No hay mensajes en esta carpeta.',
  inboxEmptyMailSub:
    'Los correos a support@ llegan solos por webhook. Usa Sincronizar mensajes solo si faltó alguno.',
  inboxPickMessage: 'Selecciona un mensaje de la lista.',
  inboxOpenFull: 'Abrir en panel completo',
  inboxExitFull: 'Volver a vista dividida',
  inboxFrom: 'De',
  inboxTo: 'Para',
  pushEnabled: 'Notificaciones push',
  sound: 'Sonido',
  quietHours: 'Horas de silencio',
  quietFrom: 'Desde',
  quietTo: 'Hasta',
  categories: 'Categorías',
  markAllRead: 'Marcar leídas',
  clearAll: 'Borrar todas',
  noNotifs: 'Todo en calma.',
  noNotifsSub: 'Aquí aparecerán las nuevas.',
  quiet: 'Horas de silencio activas',

  cat_cutoff: 'Cierres',
  cat_results: 'Resultados',
  cat_limits: 'Límites',
  cat_routes: 'Rutas',
  cat_users: 'Usuarios',
  cat_messages: 'Mensajes',
  cat_integrity: 'Integridad',
  cat_system: 'Sistema',
  cat_summary: 'Resumen',
};

export default esInbox;
